import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { environment } from '../../../../environments/environment';
import { ContactModalService } from '../../services/contact-modal.service';
import { QuickContactFormComponent } from '../quick-contact-form/quick-contact-form.component';

@Component({
  selector: 'app-contact-modal',
  imports: [LucideAngularModule, QuickContactFormComponent],
  templateUrl: './contact-modal.component.html',
  styleUrl: './contact-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactModalComponent {
  private readonly router = inject(Router);
  private readonly contactModalService = inject(ContactModalService);

  readonly visible = this.contactModalService.visible;
  readonly whatsappUrl = environment.company.whatsappUrl;
  readonly phoneFormatted = environment.company.phoneFormatted;
  readonly phoneRaw = environment.company.phone;

  close(): void {
    this.contactModalService.close();
  }

  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-overlay')) {
      this.close();
    }
  }

  onWhatsapp(): void {
    window.open(this.whatsappUrl, '_blank', 'noopener,noreferrer');
    this.close();
  }

  onPhone(): void {
    window.location.href = `tel:${this.phoneRaw}`;
    this.close();
  }

  onScheduleVisit(): void {
    this.close();
    this.router.navigate(['/contact']);
  }
}
